<bl-dynamic-guide-content
 #content
 [title]="'車両追加顧客選択'"
 [guideContents]="guideContents"
>
</bl-dynamic-guide-content>



// WEBPACK FOOTER //
// ./src/app/page/profile-entries-page/customer-select-guide/customer-select-guide.component.html